var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles.footer},[_c('div',{class:_vm.styles.content},[_c('span',{staticClass:"color-white"},[_vm._v("You are currently using a Free version. Upgrade to unlock our awesome features!")]),(_vm.is_group_admin)?_c('Button',{attrs:{"type":"success","label":"Upgrade"},on:{"click":_vm.upgradeClickHandler}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }